import { QUERY_KEYS } from 'api/query-keys';
import { DuplicateShiftRequestDto } from 'api/services/shift/shift-service.dto';
import { sharedShiftService } from 'api/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { useSiteDetection } from 'shared/hooks';

type ShiftMutationOptions = UseMutationOptions<string[], Error, DuplicateShiftRequestDto>;

export const useDuplicateShift = () => {
  const queryClient = useQueryClient();
  const { site } = useSiteDetection();

  const mutationFn = async (shift: DuplicateShiftRequestDto) =>
    await sharedShiftService.duplicateShift(site, shift);
  const options: ShiftMutationOptions = {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shifts());
    },
  };

  return useMutation(mutationFn, options);
};
